import { PrintMailModalContentProps } from "../../../../commons/types/modal";
import { useCommonAppDispatcher } from "../../store/hooks";
import { useSettings } from "../queries/use-settings";

type Data = PrintMailModalContentProps["data"];
type OnClose = PrintMailModalContentProps["onClose"];

export type ShareAction = ReturnType<typeof usePrintOrMail>["mail" | "print" | "printOrMail"];

const usePrintOrMail = () => {
  const [dispatch, actions] = useCommonAppDispatcher();
  const settings = useSettings();

  const isPrintingActive = settings.initialized.printing.active;
  const isMailActive = settings.initialized.mail.active;

  const print = (data: Data, onClose?: OnClose) => {
    dispatch(actions.modal.showModal("print", { data, onClose }));
  };

  const mail = (data: Data, onClose?: OnClose) => {
    dispatch(actions.modal.showModal("mail", { data, onClose }));
  };

  const printOrMail = (data: Data, onClose?: OnClose) => {
    if (isPrintingActive && isMailActive) {
      dispatch(actions.modal.showModal("printMailSwitch", { data, onClose }));
    } else if (isPrintingActive) {
      dispatch(actions.modal.showModal("print", { data, onClose }));
    } else if (isMailActive) {
      dispatch(actions.modal.showModal("mail", { data, onClose }));
    }
  };

  return { print, mail, printOrMail, isPrintingActive, isMailActive };
};

export default usePrintOrMail;
